
// src/routes/SigninCallback.tsx
import { useEffect, useState } from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import { Spinny } from '../components/Spinny';
import { createUserManager } from 'redux-oidc-2';
import { authSettings } from '../settings/authSettings';
import { useSearchParams } from 'react-router-dom';
import { getUserManager } from '../redux/store';
import { useReduxSelector } from '../redux/hooks/hooks';


export default function SigninCallback() {
  const [message, setMessage] = useState('Completing sign-in….');
  const [isLoading, setIsLoading] = useState(true);

  //const [params] = useSearchParams();
  //const revTenantId = params.get("revTenantId") || "";
  // let setting = authSettings;
  // if (revTenantId) {
  //   setting.authority = setting.authority.replace("/common", `/${revTenantId}`);
  //   setting.redirect_uri = `${window.location.origin}/signin-callback?revTenantId=${revTenantId}`;
  // }
  //the tenantId saved in a cookie
  const cookieTenantId = document.cookie.split(";").find(cookie => cookie.trim().startsWith("revTenantId="))?.split("=")[1];
  //const revTenantId = useReduxSelector((state) => state.rev.tenantUid);
  const userManager = getUserManager(cookieTenantId);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        console.log('Processing signin callback with user manager for tenant:', userManager.settings.authority, cookieTenantId);
        const user = await userManager.signinRedirectCallback();
        console.log('Notifying Teams of successful auth with user:', user, microsoftTeams?.app, microsoftTeams?.authentication);

        // If hosted inside Teams popup
        if (microsoftTeams?.app && microsoftTeams?.authentication) {
          await microsoftTeams.app.initialize();

          microsoftTeams.authentication.notifySuccess(JSON.stringify(user));
          setMessage('Sign-in succeeded. You can close this window.');
          setIsLoading(false);
          // Optionally close the popup:
          // window.close();
        } else {
          // Non-Teams fallback: redirect to app root (or wherever)
          console.log('Sign-in succeeded Non-Teams fallback. Redirecting…');
          setIsLoading(false);
          window.location.replace('/');
        }
      } catch (err: any) {
        console.error('signinRedirectCallback error:', err);

        await microsoftTeams.app.initialize();

        console.log('Initialized Teams app context in error handler', microsoftTeams?.authentication);

        if (microsoftTeams?.app && microsoftTeams?.authentication) {
          //await microsoftTeams.app.initialize();
          // microsoftTeams.authentication.notifyFailure(
          //   typeof err === 'string' ? err : JSON.stringify(err)
          // );
          setMessage('Sign-in failed. Please close the window and try again.');
          setIsLoading(false);


          //microsoftTeams.authentication.notifyFailure('Sign-in failed. Please close the window and try again. Details: ' + (typeof err === 'string' ? err : JSON.stringify(err)));

          console.log('Notified Teams of auth failure');
        } else {
          setMessage('Sign-in failed.');
          setIsLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (isLoading ? <Spinny text={message} /> : <div className='alert alert-info p-3'>{message}</div>);
}
